import StoreProvider from 'diy/redux/StoreProvider';
import ResourceManager from 'diy/resources/Manager';
import DragDrop = require('diy/module/common/js/DragDrop');

class AppRegistry {
    private storeProvider: StoreProvider;
    private resourceManager: ResourceManager;
    private moduleDragDrop: DragDrop;

    setStoreProvider(storeProvider: StoreProvider): AppRegistry {
        this.storeProvider = storeProvider;
        return this;
    }

    getStoreProvider(): StoreProvider {
        return this.storeProvider;
    }

    getResourceManager(): ResourceManager {
        return this.resourceManager;
    }

    setResourceManager(resourceManager: ResourceManager): AppRegistry {
        this.resourceManager = resourceManager;
        return this;
    }
    setModuleDragDrop(dragDrop: DragDrop) {
        this.moduleDragDrop = dragDrop;
    }
    getModuleDragDrop() {
        return this.moduleDragDrop;
    }
}

export default new AppRegistry();



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/AppRegistry.ts
 **/